import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Pricing() {
  const { t } = useTranslation()

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow">Almus</p>
        <h1 className="section-title">{t('pricing.title')}</h1>
        <p className="section-sub">{t('pricing.text')}</p>
        <div className="price-panel">
          <p>{t('pricing.cta')}</p>
          <Link to="/contact" className="btn btn-primary" style={{ marginTop: 24 }}>{t('hero.cta')}</Link>
        </div>
      </div>
    </section>
  )
}